import React, { PureComponent } from "react";
import { Modal } from "react-bootstrap";
import EventEmitter from "../../../services/event-emitter";
import DebtButton from "../../../components/finance/decisions/debt-button";
import EquityButton from "../../../components/finance/decisions/equity-button";

class ReturnCapitalSelectModal extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      show: false
    };

    this.eventemitter = EventEmitter.getInstance();
  }

  close = () => {
    this.setState({
      show: false
    });
  };

  show = () => {
    this.setState({
      show: true
    });
  };

  componentDidMount() {
    this.eventemitter.on("show-return-capital-select-modal", this.show);
    this.eventemitter.on("hide-return-capital-select-modal", this.close);
  }

  componentWillUnmount() {
    this.eventemitter.off("show-return-capital-select-modal", this.show);
    this.eventemitter.off("hide-return-capital-select-modal", this.close);
  }

  render() {
    const { show } = this.state;
    const { onDebt, onEquity, equityEnabled } = this.props;

    return (
      <Modal id="returnCapitalSelectModal" show={show} onHide={this.close}>
        <Modal.Header closeButton={true}>
          <h4 className="fn-decisions-modal-title">
            Please click on the type of capital
            <br />
            you want to return or modify?
          </h4>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <DebtButton onClick={onDebt} />
            <EquityButton onClick={onEquity} disabled={!equityEnabled} />
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default ReturnCapitalSelectModal;



// WEBPACK FOOTER //
// ./src/components/finance/decisions/return-capital-select-modal.js